import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Staggered reveal for direct children (or [data-reveal] descendants) on scroll.
export const useReveal = (deps = []) => {
  const ref = useRef(null);
  useEffect(() => {
    const scope = ref.current;
    if (!scope) return;
    const targets = scope.querySelectorAll("[data-reveal]");
    if (!targets.length) return;
    const ctx = gsap.context(() => {
      targets.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 44 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power3.out",
            delay: parseFloat(el.dataset.revealDelay || 0),
            scrollTrigger: { trigger: el, start: "top 88%", once: true },
          }
        );
      });
    }, scope);
    return () => ctx.revert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return ref;
};

// Parallax: moves element by given amount as it scrolls through viewport.
export const useParallax = (amount = 80) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        el,
        { y: -amount / 2 },
        { y: amount / 2, ease: "none", scrollTrigger: { trigger: el, start: "top bottom", end: "bottom top", scrub: true } }
      );
    });
    return () => ctx.revert();
  }, [amount]);
  return ref;
};
